"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareType = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var ShareType;
(function (ShareType) {
    ShareType["CopyLink"] = "copy-link";
    ShareType["Email"] = "email";
    ShareType["Facebook"] = "facebook";
    ShareType["Instagram"] = "instagram";
    ShareType["Link"] = "link";
    ShareType["LinkedIn"] = "linkedin";
    ShareType["Twitter"] = "twitter";
})(ShareType = exports.ShareType || (exports.ShareType = {}));
//# sourceMappingURL=contracts.js.map